import React from 'react'
import { Button, Modal } from 'react-bootstrap'

type UnsavedWarningModalProps = {
  showWarningModal: boolean
  onCancel: VoidFunction
  onContinue: VoidFunction
  leavingPost: boolean
}

export const UnsavedWarningModal = ({
  showWarningModal,
  onCancel,
  onContinue,
  leavingPost,
}: UnsavedWarningModalProps) => {
  const warningMessage = leavingPost
    ? 'You have changes in progress. Do you still want to leave this post?'
    : 'You have other changes in progress.'
  const cancelText = leavingPost ? 'Cancel' : 'Go back'
  return (
    <Modal show={showWarningModal} onHide={onCancel} data-testid={'unsaved-warning-modal'}>
      <Modal.Body>
        <p>{warningMessage}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onCancel} data-testid={'modal-cancel'}>
          {cancelText}
        </Button>
        <Button variant="primary" onClick={onContinue} data-testid={'modal-continue'}>
          Discard Changes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
